export default __webpack_public_path__ + "static/media/menu-logo.600a81e5.svg";